import {useQuery} from '@tanstack/react-query'
import useGigyaSSR from './use-gigya-ssr'

const useGigyaCustomer = (customer, /*  email, */ options) => {
    const {getAccountInfo} = useGigyaSSR()

    const fetchAccountInfo = async () => {
        try {
            /* let regToken = null
            if (customer?.isGuest && email) {
                const response = await getLiteToken(email)
                regToken = response?.token
            } */

            return await getAccountInfo(customer?.c_gigyaId /* , regToken */)
        } catch (error) {
            throw new Error('Failed to fetch account info: ' + error.message)
        }
    }

    return useQuery(
        ['gigyaAccountInfo', customer?.c_gigyaId, /*  email, */ customer.lastModified],
        fetchAccountInfo,
        options,
    )
}

export default useGigyaCustomer
